import Http from "../util/httpUtils"
import { ONLINE_HTTP } from "../constants/conf"

export default {
  getFloorList: function(marketId) {
    return new Promise((resolve, reject) => {
      let list = [-1, 1, 2, 3, 4, 5, 6, 7, 8].map(f => {
        return {
          floor: f,
          name: f > 0 ? f + "F" : "B" + Math.abs(f),
        }
      })
      resolve(list)
    })
  },
  floorFeatures: function(site, floor) {
    return Http.get(
      `data/map.json`,
      { site: site, floor: floor },
      {
        expire: 600,
        key: `floorFeature_${site}`,
        store: sessionStorage,
        fromCache: true,
      }
    )
  },
  /**
   *
   * @param param {site:1, floor:1, date: , time: }
   */
  floorHot: function(param) {
    return Http.get(ONLINE_HTTP + "/api/v1/heat_map", param)
  },
  /**
   *
   * @param site
   * @param floor
   */
  getVistorCount: function(site, floor) {
    return Http.get(ONLINE_HTTP + "/api/v1/visitor_count", { site, floor })
  },
}
